import { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom"; // Added useNavigate

import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem"; // Added MenuItem
import Icon from "@mui/material/Icon";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import { useMediaQuery } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { TextField } from "@mui/material";
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
import { Select, FormControl, InputLabel } from "@mui/material";
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [accountMenu, setAccountMenu] = useState(null); // for account_circle menu
  const route = useLocation().pathname.split("/").slice(1);
  const navigate = useNavigate(); // for programmatic navigation
  const isMobileOrTablet = useMediaQuery("(max-width:1200px)");

  const [colleges, setColleges] = useState([]);
  const [loadingColleges, setLoadingColleges] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // fetch college list based on email + client_id
  const fetchUserColleges = async () => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("user"));
      if (!storedUser) return;

      const clientId = storedUser.client_id;
      const email = storedUser.user_email;

      const res = await fetch(`${API_BASE_URL}/api/user-college/${clientId}/${email}`);
      const data = await res.json();
      if (data.success) {
        setColleges(
          data.data.colleges.map((c) => ({
            id: c.college_id,
            name: c.college_name + "-" + c.college_id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load colleges:", error);
    } finally {
      setLoadingColleges(false);
    }
  };
  useEffect(() => {
    fetchUserColleges();
  }, []);

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Notifications menu
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Account menu
  const handleAccountMenuOpen = (event) => setAccountMenu(event.currentTarget);
  const handleAccountMenuClose = () => setAccountMenu(null);
  const handleLogout = () => {
    sessionStorage.removeItem("token");
    const landingPage = localStorage.getItem("landingPage");
    localStorage.removeItem("landingPage");

    if (!landingPage) navigate("/authentication/sign-in");
    else window.location.href = landingPage;
  };
  let storedUser = null;
  const userJson = sessionStorage.getItem("user");

  if (userJson) {
    try {
      storedUser = JSON.parse(userJson);
    } catch (e) {
      console.error("Failed to parse user from sessionStorage:", e);
      storedUser = null;
    }
  }
  const [selectedCollege, setSelectedCollege] = useState(storedUser?.college_id || "");

  const handleCollegeChange = (event) => {
    const newCollegeId = event.target.value;
    if (newCollegeId === null || newCollegeId === undefined || newCollegeId === "") {
      alert("Please select a valid College");
      return; // stop execution
    }
    setSelectedCollege(newCollegeId);

    if (storedUser) {
      const updatedUser = { ...storedUser, college_id: newCollegeId };
      sessionStorage.setItem("user", JSON.stringify(updatedUser));
      navigate(0);
    }
  };
  const username = storedUser?.user_name || "Guest";
  const token = sessionStorage.getItem("token"); // Or however you store it
  let tokenEmail = "Guest";
  if (token) {
    try {
      const decoded = jwtDecode(token);
      tokenEmail = decoded.user_email || "Guest";
    } catch (error) {
      console.error("Failed to decode token:", error);
    }
  }
  const renderNotificationsMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" />
    </Menu>
  );

  const renderAccountMenu = () => (
    <Menu
      anchorEl={accountMenu}
      open={Boolean(accountMenu)}
      onClose={handleAccountMenuClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ mt: 2 }}
    >
      <MenuItem>
        <Icon fontSize="small" sx={{ mr: 1 }}>
          person
        </Icon>
        College-{storedUser?.college_id} <br></br>
        {username} <br></br>
        {tokenEmail}
      </MenuItem>
      <MenuItem
        onClick={() => {
          navigate("/profile");
          handleAccountMenuClose();
        }}
      >
        <Icon fontSize="small" sx={{ mr: 1 }}>
          settings
        </Icon>
        Profile
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <Icon fontSize="small" sx={{ mr: 1 }}>
          logout
        </Icon>
        Logout
      </MenuItem>
    </Menu>
  );
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;
      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }
      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => ({
        ...navbar(theme, { transparentNavbar, absolute, light, darkMode }),
        color: "red", // This will override the text/icon color
        backgroundColor: "white", // Optional: Custom background
      })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {!isMobileOrTablet && (
          <IconButton onClick={() => setMiniSidenav(dispatch, !miniSidenav)}>
            <Icon sx={iconsStyle} fontSize="medium">
              {miniSidenav ? "menu_open" : "menu"}
            </Icon>
          </IconButton>
        )}
        {/*<MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox>*/}
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          {/* Extracting the last segment from the route */}
          <h4 style={{ margin: 0 }}>
            {route.length > 0
              ? route[route.length - 1].charAt(0).toUpperCase() + route[route.length - 1].slice(1)
              : "Home"}
          </h4>
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox pr={1}>
              <TextField
                label="College"
                name="college"
                select
                fullWidth
                InputLabelProps={{ shrink: true }}
                SelectProps={{ native: true }}
                value={selectedCollege}
                onChange={(e) => handleCollegeChange(e)}
              >
                <option value="">Select College</option>

                {loadingColleges && <option>Loading...</option>}

                {!loadingColleges &&
                  colleges.map((college) => (
                    <option key={college.id} value={college.id}>
                      {college.name}
                    </option>
                  ))}
              </TextField>
            </MDBox>

            <MDBox pr={1}>
              <MDInput label="Search here" />
            </MDBox>
            <MDBox color={light ? "white" : "inherit"}>
              {/* Changed this Link to just an IconButton that opens account menu */}
              <IconButton
                sx={navbarIconButton}
                size="small"
                disableRipple
                onClick={handleAccountMenuOpen}
              >
                <Icon sx={iconsStyle}>account_circle</Icon>
              </IconButton>
              {renderAccountMenu()}
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
                <Icon sx={iconsStyle}>settings</Icon>
              </IconButton>
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon sx={iconsStyle}>notifications</Icon>
              </IconButton>
              {renderNotificationsMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
